var _excluded = ["classes", "loading", "label", "icon", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { memo } from 'react';
import Loader from 'react-loader-spinner';
import { mergeClasses } from '../../../classify';
import defaultClasses from './button.css';
var Button = props => {
  var {
      classes: propClasses,
      loading,
      label,
      icon,
      disabled
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = mergeClasses(defaultClasses, propClasses);
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    disabled: disabled,
    className: classes.button
  }), loading ? /*#__PURE__*/React.createElement(Loader, {
    type: "Oval",
    height: '100%',
    width: 30,
    color: "#FFFFFF"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: "buttonImage"
  }), label));
};
export default memo(Button);